import {
    Card,
    CardActionArea,
    CardContent,
    Grid,
    Typography,
} from '@mui/material';
import { AddCircleOutline } from '@mui/icons-material';
import moment from 'moment';
import React from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import Screen from '../../components/fragments/Screen';

export default function NotepadScreen() {
    const navigate = useNavigate();
    const state = useSelector((st) => st);

    const { notes } = state.local;

    return (
        <Screen authPass title={'Notepad'}>
            <Grid item xs={6}>
                <CardActionArea
                    className="h-100"
                    onClick={() => navigate('/bible-tools/notepad-add')}
                >
                    <Card variant="outlined" className="h-100">
                        <CardContent className="d-flex align-items-center justify-content-center h-100">
                            <AddCircleOutline
                                color="primary"
                                style={{
                                    width: 50,
                                    height: 50,
                                }}
                            />
                        </CardContent>
                    </Card>
                </CardActionArea>
            </Grid>
            {notes?.map((note) => (
                <NoteCard key={note.id} note={note} />
            ))}
        </Screen>
    );
}

const NoteCard = ({ note }) => {
    const navigate = useNavigate();

    return (
        <Grid item xs={6}>
            <Card variant="outlined" className="h-100">
                <CardActionArea
                    onClick={() =>
                        navigate(`/bible-tools/notepad/${note?.id}`, {
                            state: note,
                        })
                    }
                    className="h-100"
                >
                    <CardContent style={{ overflow: 'hidden' }}>
                        <Typography className="fw-bold">
                            {note?.title}
                        </Typography>
                        <Typography>
                            {note.note?.slice(0, 40) + '...'}
                        </Typography>
                        <Typography color="textSecondary">
                            {moment(note.id).fromNow()}
                        </Typography>
                    </CardContent>
                </CardActionArea>
            </Card>
        </Grid>
    );
};
